export default class MarcheDto {
  id;
  reference;
  typeMarche;
  groupement;
  libelleCourt;
  libelleLong;
  titulaire;
  dateDebut;
  dateFin;
  infosLigne = [];
  tranches = [];
  secteurGeographique;
  territoire;
  territoireGeo;
  createdDate;
  termine;
  directionPrescriptricePrincipale;
  commentaire;
}